export const company_name = "Parent%20Inc."
export const url = "http://localhost:5001"
// export const url = "http://amazing_pare"
// export const use_api = true
export const use_api = false
export const sleep_for_api_testing = 1000
export const sleep = ms => new Promise(
    resolve => setTimeout(resolve, ms)
);


// This is sample API data for frontend only
export const get_legal_chart_api_data = {
    "Parent Inc.": {
        "Foreign Company Limited": {},
        "Subsidiary 1 Corporation": {},
        "Subsidiary 2 Inc.": {}
    }
  }

export const get_cod_changes_api_data = {
    "Category": {
        "0": "Direct COD",
        "13": "COD After Reductions in Basis of Property",
        "28": "COD After Reductions in Basis of Property",
        "55": "COD After Reductions in Basis of Property",
        "85": "COD After Reductions in Basis of Property",
        "147": "COD After Reductions in Foreign Tax Credits",
        "148": "Black Hole COD"
    },
    "Class": {
        "0": "Start",
        "13": "Class i",
        "28": "Class ii",
        "55": "Class iii",
        "85": "Class i",
        "147": "Foreign Tax Credits",
        "148": "Final"
    },
    "Company": {
        "0": "Parent Inc.",
        "13": "Parent Inc.",
        "28": "Parent Inc.",
        "55": "Parent Inc.",
        "85": "Parent Inc.",
        "147": "Parent Inc.",
        "148": "Parent Inc."
    },
    "Elect B5": {
        "0": true,
        "13": true,
        "28": true,
        "55": true,
        "85": false,
        "147": false,
        "148": true
    },
    "Inputs": {
        "0": null,
        "13": 1,
        "28": 1,
        "55": 1,
        "85": 0,
        "147": null,
        "148": null
    },
    "Secured CODI": {
        "0": 173748681.9,
        "13": 149572477.04000002,
        "28": 131709346.99799003,
        "55": 130135866.74297085,
        "85": 55211092.27167536,
        "147": null,
        "148": null
    },
    "Timestamp": {
        "0": "Sun, 01 Jan 2023 21:28:05 GMT",
        "13": "Sun, 01 Jan 2023 21:28:05 GMT",
        "28": "Sun, 01 Jan 2023 21:28:05 GMT",
        "55": "Sun, 01 Jan 2023 21:28:05 GMT",
        "85": "Sun, 01 Jan 2023 21:28:06 GMT",
        "147": "Sun, 01 Jan 2023 21:28:06 GMT",
        "148": "Sun, 01 Jan 2023 21:28:06 GMT"
    },
    "Total CODI": {
        "0": 0,
        "13": 197835999.79000002,
        "28": 179972869.74799,
        "55": 177822803.99000004,
        "85": 75442623.81170356,
        "147": 67423329.81170356,
        "148": 0
    },
    "Total CODI Difference": {
        "0": 222012204.65,
        "13": 24176204.859999985,
        "28": 17863130.04201001,
        "55": 2150065.757989973,
        "85": 102380180.17829648,
        "147": 8019294,
        "148": 67423329.81170356
    },
    "Unsecured CODI": {
        "0": 48263522.75,
        "13": 48263522.75,
        "28": 48263522.75,
        "55": 47686937.247029185,
        "85": 20231531.5400282,
        "147": null,
        "148": null
    }
}

export const get_codi_api_data = {
    "secured_codi": 173748681.9,
    "unsecured_codi": 48263522.75
}

export const get_property_names_api_data = [
    "Assets",
    "Liabilities",
    "Member Stock",
    "Non-Member Stock",
    "Foreign Stock",
    "NOLs",
    "GBCs",
    "Min Tax",
    "Capital Loss",
    "Sec 469(b)",
    "FTCs",
    "163(j)",
    "Sec 1017"
]

export const get_input_data_api_data = {
    "Parent Inc.": {
        "Assets": {
            "columns": [
                "Property",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": 100,
                    "Book Value": 8164514.579999999,
                    "Property": "Cash",
                    "Tax Basis - Initial": 8164614.579999999
                },
                {
                    "Adjustments": 342982,
                    "Book Value": 18609980.9,
                    "Property": "Accounts Receivable",
                    "Tax Basis - Initial": 18952962.9
                },
                {
                    "Adjustments": -2725221,
                    "Book Value": 2846823.02,
                    "Property": "Prepaid Expenses - Secured",
                    "Tax Basis - Initial": 121602.02000000002
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Prepaid Expenses - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": -6780042.0146,
                    "Book Value": 20969051.08,
                    "Property": "Inventory",
                    "Tax Basis - Initial": 14189009.065399997
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Other Current Assets",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Construction in Progress",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land - Secured",
                    "Tax Basis - Initial": 3103815
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land Improvements - Secured",
                    "Tax Basis - Initial": 174919.42
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land Improvements - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Buildings - Secured",
                    "Tax Basis - Initial": 21751452.33
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Buildings - Unsecured",
                    "Tax Basis - Initial": 150000
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Machinery & Equipment - Secured",
                    "Tax Basis - Initial": 348049.63
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Machinery & Equipment - Unsecured",
                    "Tax Basis - Initial": 100000
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Furniture & Fixtures - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Furniture & Fixtures - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Office Equipment - Secured",
                    "Tax Basis - Initial": 43907.2
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Office Equipment - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Leasehold Improvement - Secured",
                    "Tax Basis - Initial": 2249833.11
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Leasehold Improvement - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Computer Software - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Computer Software - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Vehicles - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Vehicles - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Oil and Gas Properties - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Oil and Gas Properties - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Goodwill - Secured",
                    "Tax Basis - Initial": 7620502.710000008
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Goodwill - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intangible Assets - Secured",
                    "Tax Basis - Initial": 841643.1199999996
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intangible Assets - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": -3290633.263333335,
                    "Book Value": 3438044.67,
                    "Property": "Deferred Financing Fees",
                    "Tax Basis - Initial": 147411.40666666487
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Intercompany Receivables",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Notes Receivable",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Other Assets",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Real Property Described 1221-1",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Liabilities": {
            "columns": [
                "Property",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial",
                "Adjustments for Restructuring",
                "Post-Restructuring"
            ],
            "data": [
                {
                    "Adjustments": 9315819.41,
                    "Adjustments for Restructuring": null,
                    "Book Value": 19790952.55,
                    "Post-Restructuring": 29106771.96,
                    "Property": "Accounts Payable",
                    "Tax Basis - Initial": 29106771.96
                },
                {
                    "Adjustments": -1746952.276610741,
                    "Adjustments for Restructuring": null,
                    "Book Value": 6934062.169999999,
                    "Post-Restructuring": 5187109.8933892585,
                    "Property": "Accrued Expenses",
                    "Tax Basis - Initial": 5187109.8933892585
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": null,
                    "Book Value": 4117940,
                    "Post-Restructuring": 4117940,
                    "Property": "Other Current Liabilities",
                    "Tax Basis - Initial": 4117940
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": -47000000,
                    "Book Value": 47000000,
                    "Post-Restructuring": 0,
                    "Property": "Debt #1",
                    "Tax Basis - Initial": 47000000
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": -23500000,
                    "Book Value": 23500000,
                    "Post-Restructuring": 0,
                    "Property": "Debt #2",
                    "Tax Basis - Initial": 23500000
                },
                {
                    "Adjustments": 12837000,
                    "Adjustments for Restructuring": -30000000,
                    "Book Value": 17163000,
                    "Post-Restructuring": 0,
                    "Property": "Debt #3",
                    "Tax Basis - Initial": 30000000
                },
                {
                    "Adjustments": -76636999.69999999,
                    "Adjustments for Restructuring": -259554091,
                    "Book Value": 336191090.7,
                    "Post-Restructuring": 0,
                    "Property": "Debt #4",
                    "Tax Basis - Initial": 259554091
                },
                {
                    "Adjustments": 65000000,
                    "Adjustments for Restructuring": -65000000,
                    "Book Value": 0,
                    "Post-Restructuring": 0,
                    "Property": "Debt #5",
                    "Tax Basis - Initial": 65000000
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 75000000,
                    "Book Value": 0,
                    "Post-Restructuring": 75000000,
                    "Property": "Debt #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 0,
                    "Post-Restructuring": 0,
                    "Property": "Intercompany Payables",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": -4535982.69,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 4535982.69,
                    "Post-Restructuring": 0,
                    "Property": "Deferred Taxes",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 1038385.39,
                    "Post-Restructuring": 1038385.39,
                    "Property": "Other Long Term Liabilities",
                    "Tax Basis - Initial": 1038385.39
                }
            ]
        },
        "Member Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": 0,
                    "Book Value": 4690969.14201,
                    "Entity ID": null,
                    "Entity Name": "Subsidiary 1 Corporation ",
                    "Property": "Stock Basis - Member Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 4690969.14201
                },
                {
                    "Adjustments": 0,
                    "Book Value": 10945594.66469,
                    "Entity ID": null,
                    "Entity Name": "Subsidiary 1 Corporation ",
                    "Property": "Stock Basis - Member Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 10945594.66469
                },
                {
                    "Adjustments": 0,
                    "Book Value": 7833812.5002,
                    "Entity ID": null,
                    "Entity Name": "Subsidiary 2 Inc.",
                    "Property": "Stock Basis - Member Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 7833812.5002
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Entity ID": null,
                    "Entity Name": "Subsidiary 2 Inc.",
                    "Property": "Stock Basis - Member Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Non-Member Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Foreign Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": 0,
                    "Book Value": 15541871.96,
                    "Entity ID": null,
                    "Entity Name": "Foreign Company Limited",
                    "Property": "Stock Basis - Foreign Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 15541871.96
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Entity ID": null,
                    "Entity Name": "Foreign Company Limited",
                    "Property": "Stock Basis - Foreign Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "NOLs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": -1810130.377299999,
                    "Book Value": 24765946,
                    "Date Created": "Thu, 25 Aug 2016 00:00:00 GMT",
                    "Property": "NOL Bucket #1",
                    "Tax Basis - Initial": 22955815.622700002
                },
                {
                    "Adjustments": 0,
                    "Book Value": 3377871,
                    "Date Created": "Sat, 31 Dec 2016 00:00:00 GMT",
                    "Property": "NOL Bucket #2",
                    "Tax Basis - Initial": 3377871
                },
                {
                    "Adjustments": 0,
                    "Book Value": 33632315,
                    "Date Created": "Mon, 31 Dec 2018 00:00:00 GMT",
                    "Property": "NOL Bucket #3",
                    "Tax Basis - Initial": 33632315
                },
                {
                    "Adjustments": 0,
                    "Book Value": 4748085,
                    "Date Created": "Tue, 31 Dec 2019 00:00:00 GMT",
                    "Property": "NOL Bucket #4",
                    "Tax Basis - Initial": 4748085
                },
                {
                    "Adjustments": 0,
                    "Book Value": 18403319,
                    "Date Created": "Thu, 31 Dec 2020 00:00:00 GMT",
                    "Property": "NOL Bucket #5",
                    "Tax Basis - Initial": 18403319
                },
                {
                    "Adjustments": 0,
                    "Book Value": 19262774.55559648,
                    "Date Created": "Fri, 31 Dec 2021 00:00:00 GMT",
                    "Property": "NOL Bucket #6",
                    "Tax Basis - Initial": 19262774.55559648
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "GBCs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Min Tax": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Capital Loss": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Sec 469(b)": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "FTCs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": 0,
                    "Book Value": 2673098,
                    "Date Created": "Fri, 31 Dec 2021 00:00:00 GMT",
                    "Property": "Foreign Tax Credits Bucket #1",
                    "Tax Basis - Initial": 2673098
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "163(j)": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": -1899643,
                    "Book Value": 16071189,
                    "Date Created": "Mon, 31 Dec 2018 00:00:00 GMT",
                    "Property": "163(j) Carryforward Bucket #1",
                    "Tax Basis - Initial": 14171546
                },
                {
                    "Adjustments": 0,
                    "Book Value": 1995315.734999999,
                    "Date Created": "Tue, 31 Dec 2019 00:00:00 GMT",
                    "Property": "163(j) Carryforward Bucket #2",
                    "Tax Basis - Initial": 1995315.734999999
                },
                {
                    "Adjustments": 0,
                    "Book Value": 23171323.79032678,
                    "Date Created": "Fri, 31 Dec 2021 00:00:00 GMT",
                    "Property": "163(j) Carryforward Bucket #3",
                    "Tax Basis - Initial": 23171323.79032678
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Sec 1017": {
            "columns": [
                "Property",
                "Amount"
            ],
            "data": [
                {
                    "Amount": 116971970.75896668,
                    "Property": "Assets"
                },
                {
                    "Amount": 32583401.63566667,
                    "Property": "Adjustments to Assets (1017 Only)"
                },
                {
                    "Amount": 114450207.24338926,
                    "Property": "Liabilities"
                },
                {
                    "Amount": 0,
                    "Property": "Adjustments to Liabilities (1017 Only)"
                }
            ]
        }
    },
    "Foreign Company Limited": {
        "Assets": {
            "columns": [
                "Property",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": 0,
                    "Book Value": -273551.63,
                    "Property": "Cash",
                    "Tax Basis - Initial": -273551.63
                },
                {
                    "Adjustments": 0,
                    "Book Value": 4460184.42,
                    "Property": "Accounts Receivable",
                    "Tax Basis - Initial": 4460184.42
                },
                {
                    "Adjustments": 0,
                    "Book Value": 81282.4,
                    "Property": "Prepaid Expenses - Secured",
                    "Tax Basis - Initial": 81282.4
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Prepaid Expenses - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": 0,
                    "Book Value": 4918612.23,
                    "Property": "Inventory",
                    "Tax Basis - Initial": 4918612.23
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Other Current Assets",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Construction in Progress",
                    "Tax Basis - Initial": 409388.8
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land - Secured",
                    "Tax Basis - Initial": 1580000
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land Improvements - Secured",
                    "Tax Basis - Initial": 51835.37
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land Improvements - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Buildings - Secured",
                    "Tax Basis - Initial": 922968.85
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Buildings - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Machinery & Equipment - Secured",
                    "Tax Basis - Initial": 11057827.219999999
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Machinery & Equipment - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Furniture & Fixtures - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Furniture & Fixtures - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Office Equipment - Secured",
                    "Tax Basis - Initial": 11127.410000000002
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Office Equipment - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Leasehold Improvement - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Leasehold Improvement - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Computer Software - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Computer Software - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Vehicles - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Vehicles - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Oil and Gas Properties - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Oil and Gas Properties - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Goodwill - Secured",
                    "Tax Basis - Initial": 1206298.29
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Goodwill - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intangible Assets - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intangible Assets - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Deferred Financing Fees",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intercompany Receivables",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Notes Receivable",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Other Assets",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Real Property Described 1221-1",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Liabilities": {
            "columns": [
                "Property",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial",
                "Adjustments for Restructuring",
                "Post-Restructuring"
            ],
            "data": [
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 5003624.5,
                    "Post-Restructuring": 5003624.5,
                    "Property": "Accounts Payable",
                    "Tax Basis - Initial": 5003624.5
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 987415.1,
                    "Post-Restructuring": 987415.1,
                    "Property": "Accrued Expenses",
                    "Tax Basis - Initial": 987415.1
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 780956.64,
                    "Post-Restructuring": 780956.64,
                    "Property": "Other Current Liabilities",
                    "Tax Basis - Initial": 780956.64
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Intercompany Payables",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": null,
                    "Book Value": 2409806.32,
                    "Post-Restructuring": 2409806.32,
                    "Property": "Deferred Taxes",
                    "Tax Basis - Initial": 2409806.32
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": null,
                    "Book Value": -297701.16,
                    "Post-Restructuring": -297701.16,
                    "Property": "Other Long Term Liabilities",
                    "Tax Basis - Initial": -297701.16
                }
            ]
        },
        "Member Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Non-Member Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Foreign Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "NOLs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "GBCs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Min Tax": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Capital Loss": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Sec 469(b)": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "FTCs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "163(j)": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Sec 1017": {
            "columns": [
                "Property",
                "Amount"
            ],
            "data": [
                {
                    "Amount": 24425973.36,
                    "Property": "Assets"
                },
                {
                    "Amount": 0,
                    "Property": "Adjustments to Assets (1017 Only)"
                },
                {
                    "Amount": 8884101.399999999,
                    "Property": "Liabilities"
                },
                {
                    "Amount": 0,
                    "Property": "Adjustments to Liabilities (1017 Only)"
                }
            ]
        }
    },
    "Subsidiary 1 Corporation": {
        "Assets": {
            "columns": [
                "Property",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Cash",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": 0,
                    "Book Value": 7362826.100000001,
                    "Property": "Accounts Receivable",
                    "Tax Basis - Initial": 7362826.100000001
                },
                {
                    "Adjustments": 0,
                    "Book Value": 1.0399999999935972,
                    "Property": "Prepaid Expenses - Secured",
                    "Tax Basis - Initial": 1.0399999999935972
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Prepaid Expenses - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": 0,
                    "Book Value": 5343904.2467,
                    "Property": "Inventory",
                    "Tax Basis - Initial": 5343904.2467
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Other Current Assets",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Construction in Progress",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land - Secured",
                    "Tax Basis - Initial": 1040000
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land Improvements - Secured",
                    "Tax Basis - Initial": 462658.35
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land Improvements - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Buildings - Secured",
                    "Tax Basis - Initial": 5356569.900000001
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Buildings - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Machinery & Equipment - Secured",
                    "Tax Basis - Initial": 146449.62999999995
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Machinery & Equipment - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Furniture & Fixtures - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Furniture & Fixtures - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Office Equipment - Secured",
                    "Tax Basis - Initial": 708.6999999999999
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Office Equipment - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Leasehold Improvement - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Leasehold Improvement - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Computer Software - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Computer Software - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Vehicles - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Vehicles - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Oil and Gas Properties - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Oil and Gas Properties - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Goodwill - Secured",
                    "Tax Basis - Initial": 624648.32
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Goodwill - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intangible Assets - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intangible Assets - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Deferred Financing Fees",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intercompany Receivables",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Notes Receivable",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Other Assets",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Real Property Described 1221-1",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Liabilities": {
            "columns": [
                "Property",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial",
                "Adjustments for Restructuring",
                "Post-Restructuring"
            ],
            "data": [
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 4019267.09,
                    "Post-Restructuring": 4019267.09,
                    "Property": "Accounts Payable",
                    "Tax Basis - Initial": 4019267.09
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 671933.19,
                    "Post-Restructuring": 671933.19,
                    "Property": "Accrued Expenses",
                    "Tax Basis - Initial": 671933.19
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 10002.199999999999,
                    "Post-Restructuring": 10002.199999999999,
                    "Property": "Other Current Liabilities",
                    "Tax Basis - Initial": 10002.199999999999
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Intercompany Payables",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Deferred Taxes",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Other Long Term Liabilities",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Member Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Non-Member Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Foreign Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "NOLs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "GBCs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Min Tax": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Capital Loss": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Sec 469(b)": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "FTCs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "163(j)": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Sec 1017": {
            "columns": [
                "Property",
                "Amount"
            ],
            "data": [
                {
                    "Amount": 20337766.2867,
                    "Property": "Assets"
                },
                {
                    "Amount": 0,
                    "Property": "Adjustments to Assets (1017 Only)"
                },
                {
                    "Amount": 4701202.4799999995,
                    "Property": "Liabilities"
                },
                {
                    "Amount": 0,
                    "Property": "Adjustments to Liabilities (1017 Only)"
                }
            ]
        }
    },
    "Subsidiary 2 Inc.": {
        "Assets": {
            "columns": [
                "Property",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Cash",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": 0,
                    "Book Value": 4330975.87,
                    "Property": "Accounts Receivable",
                    "Tax Basis - Initial": 4330975.87
                },
                {
                    "Adjustments": 0,
                    "Book Value": 13600.459999999992,
                    "Property": "Prepaid Expenses - Secured",
                    "Tax Basis - Initial": 13600.459999999992
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Prepaid Expenses - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": 0,
                    "Book Value": 3660073.5902,
                    "Property": "Inventory",
                    "Tax Basis - Initial": 3660073.5902
                },
                {
                    "Adjustments": 0,
                    "Book Value": 0,
                    "Property": "Other Current Assets",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Construction in Progress",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land - Secured",
                    "Tax Basis - Initial": 936494.75
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land Improvements - Secured",
                    "Tax Basis - Initial": 152036.33000000002
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Land Improvements - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Buildings - Secured",
                    "Tax Basis - Initial": 2748165.07
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Buildings - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Machinery & Equipment - Secured",
                    "Tax Basis - Initial": 823180.7699999999
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Machinery & Equipment - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Furniture & Fixtures - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Furniture & Fixtures - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Office Equipment - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Office Equipment - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Leasehold Improvement - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Leasehold Improvement - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Computer Software - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Computer Software - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Vehicles - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Vehicles - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Oil and Gas Properties - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Oil and Gas Properties - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Goodwill - Secured",
                    "Tax Basis - Initial": 594676.07
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Goodwill - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intangible Assets - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intangible Assets - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Deferred Financing Fees",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Intercompany Receivables",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Notes Receivable",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Other Assets",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Property": "Real Property Described 1221-1",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Liabilities": {
            "columns": [
                "Property",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial",
                "Adjustments for Restructuring",
                "Post-Restructuring"
            ],
            "data": [
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 4873960.95,
                    "Post-Restructuring": 4873960.95,
                    "Property": "Accounts Payable",
                    "Tax Basis - Initial": 4873960.95
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 533865.87,
                    "Post-Restructuring": 533865.87,
                    "Property": "Accrued Expenses",
                    "Tax Basis - Initial": 533865.87
                },
                {
                    "Adjustments": 0,
                    "Adjustments for Restructuring": 0,
                    "Book Value": 17563.59,
                    "Post-Restructuring": 17563.59,
                    "Property": "Other Current Liabilities",
                    "Tax Basis - Initial": 17563.59
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Debt #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Intercompany Payables",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Deferred Taxes",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Adjustments for Restructuring": null,
                    "Book Value": null,
                    "Post-Restructuring": 0,
                    "Property": "Other Long Term Liabilities",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Member Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Member Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Non-Member Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Non-Member Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Foreign Stock": {
            "columns": [
                "Property",
                "Entity Name",
                "Entity ID",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 1 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 1 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 2 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 2 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 3 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 3 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 4 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 4 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 5 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 5 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 6 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 6 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 7 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 7 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 8 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 8 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 9 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 9 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 10 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 10 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 11 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 11 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 12 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 12 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 13 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 13 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 14 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 14 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 15 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 15 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 16 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 16 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 17 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 17 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 18 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 18 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 19 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 19 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 20 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 20 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 21 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 21 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 22 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 22 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 23 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 23 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 24 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 24 - Unsecured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 25 - Secured",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Entity ID": null,
                    "Entity Name": null,
                    "Property": "Stock Basis - Foreign Subsidiary 25 - Unsecured",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "NOLs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "NOL Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "GBCs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "GBC Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Min Tax": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Minimum Tax Credit Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Capital Loss": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Capital Loss Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Sec 469(b)": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Section 469(b) Attributes Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "FTCs": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "Foreign Tax Credits Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "163(j)": {
            "columns": [
                "Property",
                "Date Created",
                "Book Value",
                "Adjustments",
                "Tax Basis - Initial"
            ],
            "data": [
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #1",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #2",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #3",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #4",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #5",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #6",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #7",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #8",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #9",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #10",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #11",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #12",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #13",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #14",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #15",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #16",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #17",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #18",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #19",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #20",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #21",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #22",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #23",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #24",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #25",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #26",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #27",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #28",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #29",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #30",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #31",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #32",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #33",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #34",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #35",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #36",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #37",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #38",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #39",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #40",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #41",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #42",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #43",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #44",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #45",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #46",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #47",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #48",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #49",
                    "Tax Basis - Initial": 0
                },
                {
                    "Adjustments": null,
                    "Book Value": null,
                    "Date Created": null,
                    "Property": "163(j) Carryforward Bucket #50",
                    "Tax Basis - Initial": 0
                }
            ]
        },
        "Sec 1017": {
            "columns": [
                "Property",
                "Amount"
            ],
            "data": [
                {
                    "Amount": 13259202.9102,
                    "Property": "Assets"
                },
                {
                    "Amount": 0,
                    "Property": "Adjustments to Assets (1017 Only)"
                },
                {
                    "Amount": 5425390.41,
                    "Property": "Liabilities"
                },
                {
                    "Amount": 0,
                    "Property": "Adjustments to Liabilities (1017 Only)"
                }
            ]
        }
    }
}